module.exports = __webpack_public_path__ + "static/media/golden-rainbow.e2707f5d.md";